import { APICallFunction } from "../pages/userMangement/role/apiCall";
import { getListByParamsAPI } from "../redux/crudSlice";
import { store } from "../store/store";
import { getLocalStorageItem } from "../utils/storageHelper";
import { applicationListAPI, salutationListAPI, menuGroupListAPI, menuListAPI, modulesListAPI, featureListAPI } from "./url";

const { dispatch, getState } = store;
const { crud } = getState();

export const ListKeys = {
    applications: 'applicationList',
    salutation: 'salutationList',
    menuGroup: 'menuGroupList',
    modules: 'modulesList',
    menu: 'menuList',
    features: 'featuresList'
}

const appId = getLocalStorageItem('ApplicationId');

export const getApplicationList: APICallFunction = async (params) => {
    const { key = ListKeys.applications, request = {} } = params
    let res = await dispatch(getListByParamsAPI({ key: key, url: applicationListAPI, params: request }));
    return res?.payload?.value;
}

export const salutationList: APICallFunction = async (params) => {
    const { key = ListKeys.salutation, request = {} } = params
    let res = await dispatch(getListByParamsAPI({ key: key, url: salutationListAPI, params: request }));
    return res?.payload?.value;
}

export const menuGroupList: APICallFunction = async (params) => {
    const { key = ListKeys.menuGroup, request = {} } = params
    request.ApplicationId = appId;
    let res = await dispatch(getListByParamsAPI({ key: key, url: menuGroupListAPI, params: request }));
    return res?.payload?.value;
}

export const modulesList: APICallFunction = async (params) => {
    const { key = ListKeys.modules, request = {} } = params
    request.ApplicationId = appId;
    let res = await dispatch(getListByParamsAPI({ key: key, url: modulesListAPI, params: request }));
    return res?.payload?.value;
}

export const menuList: APICallFunction = async (params) => {
    const { key = ListKeys.menu, request = {}, state } = params
    request.ApplicationId = appId;
    request.ModuleId = state?.ModuleId
    let res = await dispatch(getListByParamsAPI({ key: key, url: menuListAPI, params: request }));
    return res?.payload?.value;
}

export const featuresList: APICallFunction = async (params) => {
    const { key = ListKeys.features, request = {} } = params
    request.ApplicationId = appId;
    let res = await dispatch(getListByParamsAPI({ key: key, url: featureListAPI, params: request }))
    return res?.payload?.value;
}